import { quickBarElements } from "@helpers/defaults";
import { select } from "@utils/function";
import ShowPlacePopup from "./showPlacePopup";
import ShowPlayerPopup from "./showPlayerPopup";

/**
 * Show player for bigsacreen
 * open popup
 */
export default function ShowPlayerPopupBigscreen(
  timePerItem,
  items,
  centerZoom,
  centerLatlng
) {
  // set center
  if (centerLatlng) {
    const [lat, lng] = centerLatlng.split(",").map(Number);
    map.setView([lat, lng], centerZoom || map.getZoom());
  }

  // ----------------------------------------
  // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/653

  if (centerZoom && !centerLatlng) {
    map.setZoom(centerZoom);
  }

  // check if items is exist
  if (!items) return;
  let itemsArray = items.split(",");
  let currentIndex = 0;

  // ----------------------------------------

  function arrayIdx() {
    if (currentIndex >= itemsArray.length) {
      currentIndex = 0;
    }
    return currentIndex++;
  }

  // first show popup
  openPopup(itemsArray[arrayIdx()]);

  // show popup every timePerPlayer seconds * 1000
  setInterval(() => {
    openPopup(itemsArray[arrayIdx()]);
  }, timePerItem * 1000);
}

/**
 * Open popup (group flights)
 *
 * @param {string} string
 */
function openPopup(string) {
  //   console.log("string", string);
  const typeOfPlace = checkStringType(string);

  if (typeOfPlace === "qucikbar") {
    const correctName = findQuickBarCorrectName(quickBarElements, string);
    const quickbaritem = select(`.${correctName}`);
    // console.log(quickbaritem);
    quickbaritem?.click();
  } else {
    // close active slider if is opened
    const activeSlider = select(".active-slider");
    activeSlider?.classList.remove("active-slider");

    const placeId = typeOfPlace === "place" ? string.replace("p", "") : string;

    // show place popup
    if (typeOfPlace === "place") {
      const currentZoom = map.getZoom();
      ShowPlacePopup({ currentZoom, placeID: placeId });
    }

    // show player popup
    if (typeOfPlace === "player") {
      ShowPlayerPopup(window["flights"], placeId);
    }
  }
}

/**
 * Check string type
 *
 * @param {string} str
 * @returns String
 */
function checkStringType(str) {
  if (/^\d+$/.test(str)) {
    // check if player (only number)
    return "player";
  } else if (str.startsWith("p")) {
    // check if place (strig start with p)
    return "place";
  } else {
    // string is not a number and not a place
    return "qucikbar";
  }
}

/**
 * Find quickbar correct name
 *
 * @param {array} array
 * @param {string} value
 */
function findQuickBarCorrectName(array, value) {
  for (const i in array) {
    if (array[i].name === value) {
      return array[i].qvalue;
    }
  }
}
